import { callExternalApi } from "./external-api.service";

const apiServerUrl = process.env.REACT_APP_API_SERVER_URL;



export const createOrUpdateEvent = async (accessToken, formData, id = null) => {
  const config = {
    url: id ? `${apiServerUrl}/api/event/update/${id}` : `${apiServerUrl}/api/event/new`,
    method: id ? "PUT" : "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data: formData
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
}

export const getEventById = async (accessToken, id) => {
  const config = {
    url: `${apiServerUrl}/api/event/${id}`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    data: {}
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
}

export const deleteEventById = async (accessToken, id) => {
  const config = {
    url: `${apiServerUrl}/api/event/${id}`,
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    data: {}
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
}

export const getEvents = async (accessToken, payload) => {
  const config = {
    url: `${apiServerUrl}/api/event/getall`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    data: payload
  };

  const { data, error } = await callExternalApi({ config });
  
    return {
      data: data || null,
      error,
    };
}

export const getAllContactsCSV = async (accessToken) => {
  const config = {
    url: `${apiServerUrl}/api/contact/csv`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    data: {}
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
}

export const getContactAffiliations = async (config) => {
  const requestConfig = {
    url: `${apiServerUrl}/api/contact/affiliations`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${config.accessToken}`,
    },
    data: {}
  };

  return await callExternalApi({ config: requestConfig }, 2);
}